/**
 * Deep link into Windows Settings → Time & language → Speech, where
 * "Manage voices" adds voices to the OneCore set the app speaks with.
 *
 * `ms-settings:speech` is the documented URI for that page and resolves on
 * Windows 10 and 11 alike, so no version branch is needed.
 *
 * Note what this page does NOT reach: Windows 11's natural voices (Ava,
 * Andrew…) install through Narrator and are keyed to Narrator and Edge, so no
 * third-party app can speak with them — see the `windows_tts` module docs. What
 * this page does offer is breadth: more languages and accents in the same
 * quality tier.
 *
 * Lives here rather than beside the macOS privacy-pane links because both the
 * onboarding picker and the Settings panel use it, and Settings must not
 * depend on onboarding.
 */
import { invoke } from "@tauri-apps/api/core";

export async function openWindowsSpeechSettings(): Promise<void> {
  const url = "ms-settings:speech";
  try {
    // The Rust command validates the scheme before handing the URI to the
    // shell; the opener plugin is the fallback if that command is unavailable.
    await invoke("open_privacy_pane", { url });
  } catch {
    const { openUrl } = await import("@tauri-apps/plugin-opener");
    await openUrl(url);
  }
}
